import { useContext } from 'react'
import { PassContext } from '../pass-context'

import Generic from './fronts/generic'
import Event from './fronts/event'
import Coupon from './fronts/coupon'
import StoreCard from './fronts/store-card'
import BoardingPass from './fronts/boarding-pass'

const applePassTypes = {
  generic : Generic,
  eventTicket : Event,
  coupon : Coupon,
  storeCard : StoreCard,
  boardingPass: BoardingPass
}

const AppleFront = () => {

  const { passType } = useContext(PassContext)

  var passFieldCount = getPassFieldData({passType})
  let PassTypeComponent = applePassTypes[passType]

  return (
    <PassTypeComponent passFieldCount={passFieldCount}/>
  )
}

const getPassFieldData = ({passType}) => {
  switch(passType) {
    case "boardingPass": {
      return {
        header: 3,
        primary: 2,
        secondary: 4,
        auxiliary: 5
      }
    }

    case "eventTicket":
    case "generic": 
    case "coupon" : 
    case "storeCard" : {
      return {
        header: 3,
        primary: 1,
        secondary: 4,
        auxiliary: 4
      }
    }

    default : {
      throw new Error("Unexpected pass type")
    }
  }
}

export default AppleFront